import {hasCookieConsentMarketing, loadYoutubeAPI} from "../Utils/Utils";

const WPBlockYouTubeEmbed = (blockElem, autoEmbedOnLoad) => {

	const youtubeId = blockElem.getAttribute('data-src');
	if(!youtubeId) {
		return;
	}

	let player = null;
	const placeholder = blockElem.querySelector('.placeholder');
	const poster = blockElem.querySelector('.poster');
	poster.addEventListener('click', (e) => {
		e.preventDefault();

		const consentGiven = hasCookieConsentMarketing();

		if(!consentGiven) {

			// Use this if we're gonna show an "alert" instead
			const cookieAlert = blockElem.querySelector('.cookie-alert-video');
			if(cookieAlert) {
				cookieAlert.classList.add('js-revealed');
			}
			else {
				if(youtubeId.includes('http')) {
					window.open(youtubeId);
				}
				else {
					window.open(`https://www.youtube.com/watch?v=${youtubeId}`);
				}
			}
		}
		else {
			loadVideo();
		}
	});

	const loadVideo = () => {

		blockElem.classList.add('js-playing');

		if(player) {
			player.playVideo();
		}
		else {

			loadYoutubeAPI(() => {

				const options = {
					videoId: youtubeId,
					//host: 'https://www.youtube-nocookie.com',
					width: '1600',
					height: '900',
					playerVars: {
						modestbranding: 1,
						playsinline: 1,
						rel: 0,
						autoplay: 1,
					},
					events: {
						//'onReady': onPlayerReady,
						'onStateChange': (e) => {
							if(e.data === YT.PlayerState.ENDED) {
								hideVideo();
							}
						}
					}
				};
				player = new YT.Player(placeholder, options);
			});
		}
	};

	const hideVideo = () => {

		blockElem.classList.remove('js-playing');
	};

	if(autoEmbedOnLoad) {
		loadVideo();
	}
};

export default WPBlockYouTubeEmbed;